import { isArray } from 'util';
import { ToolCategory } from '../tool-category';

export class ToolCategoryBuilder {
  static fromJson(json) {
    return (json)
      ? new ToolCategory(
        json.hash,
        json.name
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(ToolCategoryBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/tool-category.builder.ts